<template>
  <el-form
    class="login-form"
    status-icon
    :rules="loginRules"
    ref="loginForm"
    :model="loginForm"
    label-width="0"
  >
    <el-form-item prop="username">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        v-model="loginForm.username"
        auto-complete="off"
        placeholder="请输入用户名"
      >
        <i slot="prefix" class="icon-yonghu"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        :type="passwordType"
        v-model="loginForm.password"
        auto-complete="off"
        placeholder="请输入密码"
      >
        <i
          class="el-icon-view el-input__icon"
          slot="suffix"
          @click="showPassword"
        ></i>
        <i slot="prefix" class="icon-mima"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            size="small"
            @keyup.enter.native="handleLogin"
            :maxlength="code.len"
            v-model="loginForm.code"
            auto-complete="off"
            placeholder="请输入验证码"
          >
            <i slot="prefix" class="icon-yanzhengma"></i>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <span
              class="login-code-img"
              @click="refreshCode"
              v-if="code.type == 'text'"
            >
              {{ code.value }}
            </span>
            <img
              :src="code.src"
              class="login-code-img"
              @click="refreshCode"
              v-else
            />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <div class="login-platform">
        <span class="login-platform-label">选择登录平台：</span>
        <el-select v-model="platform" @change="changePlatform">
          <el-option
            v-for="item in platformSelectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click.native.prevent="handleLogin"
        class="login-submit"
      >
        登录
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { platform } from '@/api/admin/menu';
import { mapGetters } from 'vuex';
import { randomLenNum } from '@/util/util';
import { localPlatformKey, defaultPlatform } from '@/const/common';
import { getQuery } from '@/util/bom';

export default {
  name: 'userlogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        code: '',
        redomStr: '',
      },
      checked: false,
      code: {
        src: '/code',
        value: '',
        len: 4,
        type: 'image',
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      passwordType: 'password',
      // 平台选择下拉
      platformSelectList: [],
      // 选择的平台id，默认dot
      platform: defaultPlatform,
    };
  },
  created() {
    this.refreshCode();
    this.getPlatform();
  },
  mounted() {
    // 从本地缓存读取平台，如果有就默认选中
    const cachePlatform = sessionStorage.getItem(localPlatformKey);
    if (cachePlatform) {
      // 兼容之前存路径的场景
      if (cachePlatform.includes('/')) {
        this.platform = defaultPlatform;
      } else {
        this.platform = cachePlatform;
      }
    }
  },
  computed: {
    ...mapGetters(['tagWel']),
  },
  props: [],
  methods: {
    getPlatform() {
      platform().then((res) => {
        this.platformSelectList = res?.data?.data;
      });
    },
    refreshCode() {
      this.loginForm.code = '';
      this.loginForm.randomStr = randomLenNum(this.code.len, true);
      this.code.type === 'text'
        ? (this.code.value = randomLenNum(this.code.len))
        : (this.code.src = `${this.codeUrl}?randomStr=${this.loginForm.randomStr}`);
    },
    showPassword() {
      this.passwordType == ''
        ? (this.passwordType = 'password')
        : (this.passwordType = '');
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('LoginByUsername', this.loginForm)
            .then(() => {
              this.$store.dispatch('GetUserInfo').then(() => {
                // 获取跳回地址，如有则跳回
                const redirectUrl = getQuery('redirect');
                // 选了平台传平台
                sessionStorage.setItem(localPlatformKey, this.platform);
                if (redirectUrl) {
                  window.location.href = decodeURIComponent(redirectUrl);
                } else {
                  // 非dot平台，直接跳转过去
                  if (this.platform != 'dot' && this.platform != 'system') {
                    window.location.href = '/m_op/';
                  } else {
                    this.$router.push({ path: this.tagWel.value });
                  }
                }
              });
            })
            .catch(() => {
              this.refreshCode();
            });
        }
      });
    },
    // 平台下拉选择
    changePlatform(value) {
      this.platform = value;
      sessionStorage.setItem(localPlatformKey, this.platform);
    },
  },
};
</script>

<style lang="scss">
.login-platform {
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  color: #666;

  .login-platform-label {
    padding-left: 10px;
  }

  .el-input input {
    border-bottom: none;
  }
}
</style>
